export const BUSINESS_REG_APP_CONSTANT = {

    PageTitle: "New Business Registration",
    PageHeader: "New Business Registration",
    StartPage: "/businessregapp/eappreg_criteria",
    ApplicationName: "EAPPREG",
    ContatUs: "http://finance.lacity.org/contact-us",
    OfficeLocation: "http://finance.lacity.org/locationshours",
    FormsLibrary: "https://finance.lacity.org/forms-list",
    AppName: "New Business Registration",
    Meta_name: "BUSINESSGRP",
    OOFHomePage: "http://finance.lacity.org",
    CreatedBy: "trc_app",
    ItemSrcType: "W07",
    UserNm: "Web - eAppReg",
    ReceiptPage: "/businessregapp/eappreg_receipt",
    paymentUrl: `${process.env.SERVER_API_URL ?? ""}/payment/transactis_pay_option?token=`,
	FASTTRACK_Meta_name: "FASTTRACKGRP",
	AddressCityLimit:"https://finance.lacity.gov/" 
    
}